import { PlusOutlined } from "@ant-design/icons";
import { Button, Checkbox, Table, Tooltip } from "antd";
import { ProhibitedArea } from "components";
import { Icon } from "semantic-ui-react";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;

const BusinessAreaDataList = ({
    businessAreaDataList,
    onCreateNewBusinessAreaData,
    onDeleteBusinessAreaData,
    onViewBusinessAreaData,
    onEditBusinessAreaData,
    onViewBusinessAreaDataHistory,
    permission,
}) => {
    if (!permission) {
        return <ProhibitedArea></ProhibitedArea>;
    }
    return (
        <div className="flex flex-1 flex-col gap-4 overflow-auto">
            <div className="scroll-webkit flex size-full flex-1 flex-col overflow-auto">
                <Table
                    size="small"
                    className="flex size-full flex-1 flex-col [&_thead]:sticky [&_thead]:top-0 [&_thead]:z-10 [&_thead]:bg-white"
                    rowKey="dataDomainId"
                    dataSource={businessAreaDataList}
                    pagination={false}
                    data-testid={CypressTestIds.BUSINESS_AREA_DATA_LIST_TABLE}
                >
                    <Column
                        width="6em"
                        render={(value, businessAreaData, index) => (
                            <>
                                <Tooltip title="Edit Business Area Data">
                                    <Icon
                                        disabled={!permission.canEdit}
                                        color="blue"
                                        name="pencil"
                                        className="action-cursor"
                                        onClick={() => onEditBusinessAreaData(businessAreaData.dataDomainId)}
                                        data-testid={CypressTestIds.BUSINESS_AREA_DATA_LIST_EDIT_BUTTON}
                                    />{" "}
                                </Tooltip>

                                <Tooltip title="View Business Area Data">
                                    <Icon
                                        disabled={!permission.canView}
                                        color="blue"
                                        name="eye"
                                        className="action-cursor"
                                        onClick={() => onViewBusinessAreaData(businessAreaData.dataDomainId)}
                                        data-testid={CypressTestIds.BUSINESS_AREA_DATA_LIST_VIEW_BUTTON}
                                    />{" "}
                                </Tooltip>
                                <Tooltip title="View Business Area Data History">
                                    <Icon
                                        disabled={!permission.canView}
                                        color="blue"
                                        name="history"
                                        className="action-cursor"
                                        onClick={() => onViewBusinessAreaDataHistory(businessAreaData.dataDomainId)}
                                        data-testid={CypressTestIds.BUSINESS_AREA_DATA_LIST_VIEW_HISTORY_BUTTON}
                                    />
                                </Tooltip>
                            </>
                        )}
                    />
                    <Column
                        width="15%"
                        dataIndex={"businessAreaName"}
                        title={"Business Area"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, businessAreaData, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="10%"
                        dataIndex={"domainName"}
                        title={"Domain"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, businessAreaData, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="20%"
                        dataIndex={"domainDescription"}
                        title={"Domain Description"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, businessAreaData, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="15%"
                        dataIndex={"domainPurpose"}
                        title={"Domain Purpose"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, businessAreaData, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="15%"
                        dataIndex={"usedForTagging"}
                        title={"Used for tagging"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, businessAreaData, index) => {
                            return <Checkbox checked={value} onChange={(e) => ({})}></Checkbox>;
                        }}
                    />
                    <Column width="10%" title={"Records"} render={(value, businessAreaData, index) => <>{businessAreaData.recordCount || 0}</>} />
                    <Column
                        width="5%"
                        render={(value, businessAreaData, index) => {
                            return (
                                <Tooltip title="Delete Business Area Data">
                                    <Icon
                                        disabled={!permission.canDelete}
                                        color="blue"
                                        name="trash alternate"
                                        className="action-cursor"
                                        onClick={() => onDeleteBusinessAreaData(businessAreaData)}
                                        data-testid={CypressTestIds.BUSINESS_AREA_DATA_LIST_DELETE_BUTTON}
                                    />{" "}
                                </Tooltip>
                            );
                        }}
                    />
                </Table>
            </div>
            <div className="flex w-full flex-none justify-end">
                <Button type="primary" disabled={!permission.canAdd} onClick={onCreateNewBusinessAreaData} data-testid={CypressTestIds.BUSINESS_AREA_DATA_ADD_NEW_BUTTON}>
                    <PlusOutlined /> Add Business Area Data
                </Button>
            </div>
        </div>
    );
};

export default BusinessAreaDataList;
